<template lang="pug">
  div(
    :style="styles.container"
  )
    button.button__action(
      @click="returnToPolicies"
    )
      i.glyphicon.glyphicon-chevron-left.icon
      |  Back to Policies
    div(
      :style="styles.pageHeader"
    )
      h1(
        :style="styles.pageHead"
      ) Create a New Policy
    policyForm
</template>
<script>
import policyForm from '../general/PolicyForm';
import store from '../../store';
import Services from '../../services/Services';
export default {
  name: 'policyNew',
  components: {
    policyForm
  },
  methods: {
    returnToPolicies() {
      this.$router.push('/policies');
    }
  },
  data() {
    return {
      blankPolicy: {
        title: '',
        rules: [],
        sequence: {}
      },
      styles: {
        container: {
          padding: '2rem'
        },
        pageHeader: {
          display: 'flex',
          padding: '0 1rem',
          width: '100%',
          position: 'relative'
        },
        pageHead: {
          fontSize: '1.5em',
          maxWidth: '600px',
          margin: '20px auto',
          fontWeight: '700',
          color: '#aaa'
        }
      }
    };
  },
  mounted() {
    Services.setInteractionTypes();
    Services.setActivePolicy(this.blankPolicy);
    Services.clearSelectedSequence();
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/PolicyNew.vue